import { render, staticRenderFns } from "./HelpCenterLandingKnowledgeBase.vue?vue&type=template&id=74ed95e4&"
import script from "./HelpCenterLandingKnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./HelpCenterLandingKnowledgeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports